<template>
    <div class="table-user">
        <div class="mb-3 text-right pt-1 table-user-header">
            <b-row class="mb-3">
                <search-field @searchValue="searchField($event)" />
                <date-filters @dateFromAction="filterTable($event)" @dateToAction="filterTable($event)" />
            </b-row>
        </div>
        <div class="scroll-x">
            <table-element
                :items="items"
                :fields="fields"
                :status="statusOptions"
                @sort="event => sortTable(event)"
                @statusFiltered="event => filterTable(event)">
                <b-dropdown
                    slot="actions"
                    slot-scope="data"
                    text="Actions"
                    size="sm"
                    variant="primary-user"
                    class="dropdown-split-arrow">
                    <b-dropdown-item
                        :to="{
                            name: 'ReplenishmentItem',
                            params: {parent: 'shipments', planId: data.item.id, parentBred: {route: $route}},
                            query: {
                                planNumber: data.item.uniqueNumber || data.item.id
                            }
                        }"
                    >
                        Open products list
                    </b-dropdown-item>
                    <b-dropdown-item
                        :to="{name: 'ShipmentSummary', params: {parent: 'shipments', planId: data.item.id, parentBred: {route: $route}}}"
                    >
                        Shipment‘s Summary
                    </b-dropdown-item>
                    <b-dropdown-item v-if="data.item.status !== 'cancel'" @click="cancelShipment(data.item.id)">Cancel</b-dropdown-item>
                    <b-dropdown-item v-if="data.item.status === 'cancel'" @click="deleteShipment(data.item.id)">Delete</b-dropdown-item>
                    <b-dropdown-item disabled>Track shipment</b-dropdown-item>
                </b-dropdown>
            </table-element>
        </div>
        <div class="table-user-footer">
            <!-- Pagination -->
            <table-pagination
                v-if="settingsPaginationFromApi.total >= quantityProductOnPage"
                @paginateAction="updatePagination"
                :settings="settingsPaginationFromApi"
                :perPageArray="quantityProductVariations"/>
        </div>
    </div>
</template>

<script>
    import {tableMixins, paginationMixin, routePaginationMixin} from '@/mixins/tableMixins'

    import TableElement from '~cp/UserPanel/Elements/TableElement'
    import SearchField from '~cp/UserPanel/Elements/SearchField'
    import DateFilters from '~cp/UserPanel/Elements/DateFilters'
    import TablePagination from '~cp/UserPanel/Elements/TablePagination'

    import replenishmentInventory from '@/assets/js/columns/replenishmentInventory'
    import replenishmentShipments from '@/assets/js/columns/replenishmentShipments'
    import shipmentStatus from '@/assets/js/status/replenishment/shipment'

    export default {
        name: 'ReplenishmentShipments',
        mixins: [tableMixins, paginationMixin, routePaginationMixin],
        components: {
            TableElement,
            SearchField,
            DateFilters,
            TablePagination
        },
        data() {
            return {
                endpoint: this.$endpoints.incomesShipment,
                fields: [...replenishmentInventory, ...replenishmentShipments],
                statusOptions: shipmentStatus,
            }
        },
        methods: {
            cancelShipment(id) {
                this.$store.dispatch('cancelReplenishment', id).then(() => this.getItems())
            },
            deleteShipment(id) {
                this.$store.dispatch('deleteReplenishment', id).then(() => this.getItems())
            }

        }
    }
</script>

<style lang="scss">
    .table-user {
        padding-top: 0;
        .table-user-header {
            position: relative;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Replenishment/ReplenishmentShipments.vue